'use client';

import Resource from '@guestyci/agni';

const QUERY_IDS = {
  GET_LISTING: 'GET_LISTING',
  GET_LISTINGS: 'GET_LISTINGS',
  GET_LISTING_FIELDS: 'GET_LISTING_FIELDS',
  GET_LISTING_PAYMENT_PROVIDER: 'GET_LISTING_PAYMENT_PROVIDER',
  GET_GROUP_PAYMENT_PROVIDER: 'GET_GROUP_PAYMENT_PROVIDER',
  GET_LISTING_MARKERS: 'GET_LISTING_MARKERS',

  CREATE_QUOTE: 'CREATE_QUOTE',
  GET_QUOTE: 'GET_QUOTE',
  CREATE_GROUP_QUOTE: 'CREATE_GROUP_QUOTE',
  GET_GROUP_QUOTE: 'GET_GROUP_QUOTE',

  SETUP_INTENTS: 'SETUP_INTENTS',

  ADD_COUPON: 'ADD_COUPON',
  GET_WEBSITE_SETTINGS: 'GET_WEBSITE_SETTINGS',
  GET_LISTINGS_CALENDAR: 'GET_LISTINGS_CALENDAR',
  GET_FEATURED_LISTINGS: 'GET_FEATURED_LISTINGS',
  GET_CITIES: 'GET_CITIES',

  GET_USER_LOCATION: 'GET_USER_LOCATION',

  GET_CURRENCY_RATE: 'GET_CURRENCY_RATE',

  GET_UPSELLS: 'GET_UPSELLS',
  GET_PAYMENT_SCHEDULE: 'GET_PAYMENT_SCHEDULE',
};

const { api: originalApi, env } = typeof window !== 'undefined' ? Resource.create({
  domain: '/pm-websites-backend',
  env: process.env.NEXT_PUBLIC_ENV_CLUSTER,
  development: 'localhost',
}) : {};

/**
 * Wraps the API client to automatically add 'capture=be-page' query parameter to all requests
 */
const createApiWrapper = (apiClient) => {
  if (!apiClient) return apiClient;

  const addCaptureParam = (options = {}) => {
    const params = options.params || {};
    return {
      ...options,
      params: {
        ...params,
        capture: 'be-page',
      },
    };
  };

  return {
    ...apiClient,
    get: (url, options) => apiClient.get(url, addCaptureParam(options)),
    post: (url, data, options) => apiClient.post(url, data, addCaptureParam(options)),
    put: (url, data, options) => apiClient.put(url, data, addCaptureParam(options)),
    patch: (url, data, options) => apiClient.patch(url, data, addCaptureParam(options)),
    delete: (url, options) => apiClient.delete(url, addCaptureParam(options)),
  };
};

const api = createApiWrapper(originalApi);

export { api, env, QUERY_IDS };
